
import { SEARCH_PARAM_NAMES } from "@/features/core-app/services/searchParams";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCallback } from "react";

interface UseAppRouterProps {
  chatSessionId?: string;
  agentId?: number;
  projectId?: number;
}

export function useAppRouter() {
  const navigate = useNavigate();
  return useCallback(
    ({ chatSessionId, agentId, projectId }: UseAppRouterProps = {}) => {
      const finalParams = [];

      if (chatSessionId)
        finalParams.push(`${SEARCH_PARAM_NAMES.CHAT_ID}=${chatSessionId}`);
      else if (agentId)
        finalParams.push(`${SEARCH_PARAM_NAMES.PERSONA_ID}=${agentId}`);
      else if (projectId)
        finalParams.push(`${SEARCH_PARAM_NAMES.PROJECT_ID}=${projectId}`);

      const finalString = finalParams.join("&");
      const finalUrl = `/app?${finalString}`;

      navigate(finalUrl);
    },
    [navigate]
  );
}

export function useAppParams() {
  const [searchParams] = useSearchParams();
  return useCallback((name: string) => searchParams.get(name), [searchParams]);
}
